<template>

    <div class="app-template sellprint d-noneX printpage">

        <div id="right-panel" class="right-panel">

            <div class="content">
                <div class="">
                    <!--animated fadeIn-->

                    <div class="row">
                        <div class="col-lg-12">
                            <form action="/" method="post" id="form" class="userForm ajaxForm">
                                <!--v-bind:style="{padding: printerPadding}"-->
                                <div id="printContent" :class="'bgWhite '+printerPaddingLeftClass+' '+printerPaddingRightClass+' '+printerFontSizeClass+' '+printerPaddingTopClass">
                                    <div class="card printerPadding">
                                        <div class="card-header text-center">
                                            <!--<strong data-contenthtml="title">xxxxxx-&#45;&#45;&#45;&#45;xxxxxx</strong>-->
                                        </div>
                                        <div class="card-body card-block">

                                            <div class="row">
                                                <div class="col-12 scrollHeightEnable600X">


                                                    <div class="text-bold text-center" v-if="!!title">{{title}}</div>


                                                    <div class="printblokk_top text-bold text-center" v-if="Array.isArray(printblokk_top) && printblokk_top.length>0">
                                                        <div v-for="e in printblokk_top">
                                                            <!--<span>{{e}}</span>-->
                                                            <template v-if="e==='{date}'">
                                                                <div class="row form-group" v-if="data.date">
                                                                    <div class="col col-12 ">
                                                                        <label type="text" id="dateTop" class="form-controlX ">{{data.date}}</label>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-if="e==='{datetime}'">
                                                                <div class="row form-group" v-if="data.datetime">
                                                                    <div class="col col-12 ">
                                                                        <label type="text" id="datetimeTop" class="form-controlX ">{{data.datetime}}</label>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-if="e!=='{date}'&&e!=='{datetime}'">
                                                                <span v-if="e===''">&nbsp;</span>
                                                                <span v-if="e!==''">{{e}}</span>
                                                            </template>
                                                        </div>
                                                    </div>


                                                    <!--<div class="row elementsTitle text-center">-->
                                                    <!--<div class="col col-12"><span data-contenthtml="row5" class=""></span></div>-->
                                                    <!--</div>-->

                                                    <!--<div class="elementContainer">-->
                                                    <!--</div>-->


                                                    <!--<div class="basketDisplayerContainer row">-->
                                                    <!--<BasketDisplayer :discount="buyer.discount" justDisplay="true"></BasketDisplayer>-->
                                                    <!--</div>-->
                                                    <!---->


                                                    <table class="w100">

                                                        <template v-for="(e, index) in purcaseItemsExtend">

                                                            <template v-if="Number(e.pack) === 1" class="table" style="border:1px solid black;">
                                                                <tr>
                                                                    <td class="">
                                                                        <!--<span :for="'text-input' + e.itemKey " class="form-control-label">{{Helper.getValueByIdAndKeyFromObjectArray("name", elements, e.itemKey) }}</span>-->
                                                                        <span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>
                                                                    </td>
                                                                    <td class="text-right price text-nowrap" style="padding-left: 4px;">
                                                                        <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemCountnum}}</span>
                                                                        x
                                                                    </td>
                                                                    <td class="text-right price text-nowrap" style="padding-left: 4px;">
                                                                        <small class="">{{prefix}}</small>
                                                                        <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemPrice}}</span>
                                                                        <small class="">{{suffix}}</small>
                                                                    </td>
                                                                    <td class="text-right price text-nowrap" style="padding-left: 4px;">
                                                                        <small class="">{{prefix}}</small>
                                                                        <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemSumPrice}}</span>
                                                                        <small class="">{{suffix}}</small>
                                                                    </td>
                                                                    <!--<td class="icons">-->
                                                                        <!--&lt;!&ndash;v-if="justDisplay=='false'"&ndash;&gt;-->
                                                                        <!--<div class="input-group">-->
                                                                            <!--<a class="btn_delrow input-group-addon " v-on:click="delrow(index)">-->
                                                                                <!--<div class=" "><i class="fa fa-times"></i></div>-->
                                                                            <!--</a>-->
                                                                        <!--</div>-->
                                                                    <!--</td>-->
                                                                </tr>


                                                            </template>
                                                            <template v-if="Number(e.pack) >= 2 && Number(e.pack) <= 7" class="table">


                                                                <tr>
                                                                    <td class="">
                                                                        <span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>
                                                                    </td>
                                                                    <td class="text-right price text-nowrap" style="padding-left: 4px;">
                                                                        <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemCountnum}}</span>
                                                                        <!--<span id="text-display' + e.itemKey + '" class="" data-id="' + e.itemKey + '">' + e.itemValue + '</span>-->

                                                                        <small class="" v-if="e.pack==='2'"> {{$t('global.pc')}}</small>
                                                                        <small class="" v-if="e.pack==='3'"> {{$t('global.kg')}}</small>
                                                                        <small class="" v-if="e.pack==='4'"> {{$t('global.l')}}</small>
                                                                        <small class="" v-if="e.pack==='5'"> {{$t('global.m')}}</small>
                                                                        <small class="" v-if="e.pack==='6'"> {{$t('global.pack')}}</small>
                                                                        <small class="" v-if="e.pack==='7'"> {{$t('global.occasion')}}</small>
                                                                    <td class="text-right price text-nowrap" style="padding-left: 4px;">
                                                                        <small class="">{{prefix}}</small>
                                                                        <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemPrice}}</span>
                                                                        <small class="">{{suffix}}</small>
                                                                    </td>
                                                                    <td class="text-right price text-nowrap" style="padding-left: 4px;">
                                                                        <small class="">{{prefix}}</small>
                                                                        <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemSumPrice}}</span>
                                                                        <small class="">{{suffix}}</small>
                                                                    </td>
                                                                </tr>

                                                            </template>


                                                        </template>

                                                    </table>


                                                    <div v-if="Number(discount_price)>0&&discount_price>0">
                                                        <table class="table">
                                                            <tr>
                                                                <td class=" extensionLineX">
                                                                    <span class="form-control-label">{{$t('global.discount')}}</span>
                                                                </td>
                                                                <td class=" text-right text-nowrap extensionLineX">
                                                                    <small class="">{{prefix}}</small>
                                                                    <span id="Xdiscount_price" class="discount_price">{{discount_price}}</span>
                                                                    <small class="">{{suffix}}</small>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>

                                                    <div>
                                                        <!--v-if="Number(sum)>0"-->
                                                        <table class="table">
                                                            <tr>
                                                                <td class="extensionLineX">
                                                                    <span class="form-control-label">{{$t('global.sumPrice')}}</span>
                                                                </td>
                                                                <td class="text-right text-nowrap extensionLineX">
                                                                    <small class="">{{prefix}}</small>
                                                                    <span id="" class="sum">{{sum}}</span>
                                                                    <small class="">{{suffix}}</small>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>


                                                    <!--<div class="row form-group discountpriceContainer">-->
                                                    <!--<div class="col col-5"><label class=" form-control-label">Kedvezmény</label></div>-->
                                                    <!--<div class="col col-6 text-right">-->
                                                    <!--&lt;!&ndash;<span readonly type="text" data-formHtml="discountprice" class="printprice"></span>&ndash;&gt;-->
                                                    <!--<label type="text" class="form-controlX discount_price">{{discount_price}}</label>-->
                                                    <!--</div>-->
                                                    <!--<div class="col col-1 text-right">-->
                                                    <!--<small class="unit form-text text-muted hover">Ft</small>-->
                                                    <!--</div>-->
                                                    <!--</div>-->


                                                    <!--<div class="row form-group">-->
                                                    <!--<div class="col col-5"><label class=" form-control-label">Végösszeg</label></div>-->
                                                    <!--<div class="col col-6 text-right">-->
                                                    <!--<label type="text" id="sum" class="form-controlX sum">{{sum}}</label>-->
                                                    <!--&lt;!&ndash;<label type="input" id="sum" class=" sum">0</label>&ndash;&gt;-->
                                                    <!--&lt;!&ndash;<input readonly type="text" id="textinput" name="sum" placeholder="" class="form-control sum">&ndash;&gt;-->
                                                    <!--</div>-->
                                                    <!--<div class="col col-1 text-right">-->
                                                    <!--<small class="unit form-text text-muted hover">Ft</small>-->
                                                    <!--</div>-->
                                                    <!--</div>-->


                                                    <div class="row form-group" v-if="Number(data.selltype)===1">
                                                        <div class="col col-12 ">
                                                            <label type="text" id="selltype1" class="form-controlX sum">{{$t('sell2.selltype1')}}</label>
                                                        </div>
                                                    </div>
                                                    <div class="row form-group" v-if="Number(data.selltype)===2">
                                                        <div class="col col-12 ">
                                                            <label type="text" id="selltype2" class="form-controlX sum">{{$t('sell2.selltype2')}}</label>
                                                        </div>
                                                    </div>

                                                    <!--<div class="row form-group" v-if="data.datetime">-->
                                                        <!--<div class="col col-12 ">-->
                                                            <!--<label type="text" id="datetime" class="form-controlX sum">{{data.datetime}}</label>-->
                                                        <!--</div>-->
                                                    <!--</div>-->

                                                    <!--<div class="printblokk_bottom text-center" v-if="!!title">{{title}}-->
                                                    <!--</div>-->
                                                    <div class="printblokk_bottom text-center" v-if="Array.isArray(printblokk_bottom) && printblokk_bottom.length>0">
                                                        <div v-for="e in printblokk_bottom">
                                                            <!--<span>{{e}}</span>-->
                                                            <template v-if="e==='{date}'">
                                                                <div class="row form-group" v-if="data.date">
                                                                    <div class="col col-12 ">
                                                                        <label type="text" id="dateBottom" class="form-controlX ">{{data.date}}</label>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-if="e==='{datetime}'">
                                                                <div class="row form-group" v-if="data.datetime">
                                                                    <div class="col col-12 ">
                                                                        <label type="text" id="datetimeBottom" class="form-controlX ">{{data.datetime}}</label>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-if="e!=='{date}'&&e!=='{datetime}'">
                                                                <span v-if="e===''">&nbsp;</span>
                                                                <span v-if="e!==''">{{e}}</span>
                                                            </template>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div id="hidedButtons" class="fFix card-footer d-none  text-center">
                                    <button v-on:click="go_new()" type="button" class="btn btn-success btn-lg btn-finish">
                                        <i class="fa fa-arrow-circle-o-left"></i> Vissza
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div><!-- .animated -->
            </div><!-- .content -->
        </div>
    </div>

</template>


<script>

    // @ is an alias to /src
    //    import Api from '@/api/Api';
    import SellHeader from '@/components/SellHeader.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import LinkToTemplate from "../components/LinkToTemplate";
    import BarcodeGenerator from '@/components/BarcodeGenerator.vue';
    import JsBarcode from 'jsbarcode';
//    import Sync from '@/components/Sync.vue';
    import BuyerSearcher from "../components/BuyerSearcher";
    import ProductSearcher from "../components/ProductSearcherMass";
    import BasketDisplayer from "../components/BasketDisplayer";
    import ProductTabs from "../components/ProductTabs";
    import moment from 'moment';
//    const {ipcRenderer} = require('electron');
//    const machineId = require('node-machine-id').machineId;
//    const machineIdSync = require('node-machine-id').machineIdSync;
    import Api from '@/api/Api';

    //    const sqlite3 = require('sqlite3').verbose();

    export default {
        name: 'Sellprint',
        data() {
            return {
                prefix: "",
                suffix: "",
                default_lang: "en",
                purcaseItems: [],
                purcaseItemsExtend: [],
                cachedElements: [],
                data: {
                    "id": "",
//                    "id_buyer": null,
                    "selltext": "",
                    "selltype": "1",
                },
                dataBase: {
                    "id": "",
                    "selltext": "",
                    "selltype": "1",
                },
                discount: 0,
                discount_price: 0,
                discount_percentage: 0,
                sum: 0,
                buyer: {},
                businesspartner: {},
                discountBand: [],
                title: "",
                printblokk_top: [],
                printblokk_bottom: [],
                printerPaddingLeft: "",
                printerPaddingRight: "",
                printerPaddingTop: "",
                printerPaddingLeftClass: 'printerPaddingLeftdef',
                printerPaddingRightClass: 'printerPaddingRightdef',
                printerPaddingTopClass: 'printerPaddingTopClass',
                printerFontSize: "",
                printerFontSizeClass: 'printerFontSizedef',
                AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    delay: 5000,
                },
                printStyle:"",
            };
        },
        props: {
            id: String,
        },
        watch: {
            // TODO -- betenni az element-re is.
            printerPaddingLeft: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerPaddingLeftClass = 'paddingLeft' + newdata;
                } else {
                    modul.printerPaddingLeftClass = '';
                }
            },
            printerPaddingRight: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerPaddingRightClass = 'paddingRight' + newdata;
                } else {
                    modul.printerPaddingRightClass = '';
                }
            },
            printerPaddingTop: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerPaddingTopClass = 'paddingTop' + newdata;
                } else {
                    modul.printerPaddingTopClass = '';
                }
            },
            printerFontSize: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerFontSizeClass = 'printerFontSize' + newdata;
                } else {
                    modul.printerFontSizeClass = '';
                }
            },
            discount: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
            purcaseItems: function (newData, oldData) {
                const modul = this;
                /*const purcaseItemsExtend = [];
                Array.prototype.forEach.call(newData, function (e) {
                    const eCopied = Object.assign({}, e);
                    console.log(eCopied);
                    const purcaseItemExtend = Object.assign(eCopied, modul.getElementByIdSync(e.itemKey));
                    purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementFromCachedElementsById(e.itemKey)));
                    console.log(purcaseItemExtend);
                    purcaseItemsExtend.push(purcaseItemExtend);
                });
                this.purcaseItemsExtend = purcaseItemsExtend;
                */
                this.purcaseItemsExtend = newData;
                modul.makeBasketCalculation();
            },
            buyer: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
            businesspartner: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
        },
//        mounted() {
//            const modul = this;
//            console.log("Sell2");
//            modul.$eventBus.$on('globalSetPurcaseItems', this.globalSetPurcaseItemsEventHandler);
//            modul.$eventBus.$on('globalSetBuyer', this.globalSetBuyerEventHandler);
//            modul.$eventBus.$on('globalSetBasketCalculation', this.globalSetBasketCalculationEventHandler);
//            modul.addContent();
//            setTimeout(function () {
//                if(document.getElementById("hidedButtons") &&document.getElementById("hidedButtons").classList){
//                    document.getElementById("hidedButtons").classList.remove("d-none");
//                }
//            },
////                15000
//                100
//            );
//            this.initListener("sellinone");
//            if (localStorage.getItem("printerPaddingLeft")) {
//                modul.printerPaddingLeft = localStorage.getItem("printerPaddingLeft");
//            }
//            if (localStorage.getItem("printerPaddingRight")) {
//                modul.printerPaddingRight = localStorage.getItem("printerPaddingRight");
//            }
//            if (localStorage.getItem("printerFontSize")) {
//                modul.printerFontSize = localStorage.getItem("printerFontSize");
//            }
//        },
        mounted() {
            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [2, 3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
            modul.default_lang = Helper.getLangDefaultLang();
            modul.addContent();
            const appVersions = document.getElementsByClassName("appVersion");
            for (let i = 0; i < appVersions.length; i++) {
              appVersions.item(i).classList.add("d-none");
            }

          setTimeout(function () {
              if (document.getElementById("hidedButtons") && document.getElementById("hidedButtons").classList) {
                document.getElementById("hidedButtons").classList.remove("d-none");
                const appVersions = document.getElementsByClassName("appVersion");
                for (let i = 0; i < appVersions.length; i++) {
                  appVersions.item(i).classList.remove("d-none");
                }
              }
              modul.$router.push({
                name: "sellinone", params: {}
              });

            },
            3000
//                100
          );
            this.initListener("sellinone");
            if (localStorage.getItem("printerPaddingLeft")) {
                modul.printerPaddingLeft = localStorage.getItem("printerPaddingLeft");
            }
            if (localStorage.getItem("printerPaddingRight")) {
                modul.printerPaddingRight = localStorage.getItem("printerPaddingRight");
            }
            if (localStorage.getItem("printerFontSize")) {
                modul.printerFontSize = localStorage.getItem("printerFontSize");
            }
            if (localStorage.getItem("printerPaddingTop")) {
                modul.printerPaddingTop = localStorage.getItem("printerPaddingTop");
            }

            // Bárkód termék
            modul.$eventBus.$on('globalReadElement', this.globalReadElementEventHandler);
            // Felületen beütött termék
            modul.$eventBus.$on('globalAddPurcaseElement', this.globalAddPurcaseElementEventHandler);
            // Buyer
            modul.$eventBus.$on('globalSetBuyer', this.globalSetBuyerEventHandler);
            if (modul.$route.params.sellId) {
                console.log("sellinone init as id: " + modul.$route.params.sellId);
                // TODO ide kell enek a lekérések, amik beolvassák az eladást!!


            } else {
                console.log("sellinone init as EMPTY");
                modul.emptyForNew();
            }
//            modul.getElementCategories();

//          modul.printStyle = '.text-justify {text-align: justify !important;}.text-nowrap {white-space: nowrap !important;}.text-truncate {overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}.text-left {text-align: left !important;}.text-right {text-align: right !important;}.text-center {text-align: center !important;}.w100 {width: 100%;}.w0 {width: 0%;}.w1 {width: 1%;}.w50 {width: 50%;}.w49 {width: 49%;}.mr15{margin-right: 15px;}.dtable {display: table;}.dtablerow {display: table-row;}.dtablecell {display: table-cell;}.dinlineblock {display: inline-block;}.valigntop{vertical-align:top;}.valignbottom{vertical-align:bottom;}.paddingLeftdef {padding-left: 20px;}.paddingLeft5 {padding-left: 5px;}.paddingLeft10 {padding-left: 10px;}.paddingLeft15 {padding-left: 15px;}.paddingLeft20 {padding-left: 20px;}.paddingLeft25 {padding-left: 25px;}.paddingLeft30 {padding-left: 30px;}.paddingLeft35 {padding-left: 35px;}.paddingLeft40 {padding-left: 40px;}.paddingLeft45 {padding-left: 45px;}.paddingLeft50 {padding-left: 50px;}.paddingLeft55 {padding-left: 55px;}.paddingLeft60 {padding-left: 60px;}.paddingLeft65 {padding-left: 65px;}.paddingLeft70 {padding-left: 70px;}.paddingLeft75 {padding-left: 75px;}.paddingRightdef {padding-right: 20px;}.paddingRight5 {padding-right: 5px;}.paddingRight10 {padding-right: 10px;}.paddingRight15 {padding-right: 15px;}.paddingRight20 {padding-right: 20px;}.paddingRight25 {padding-right: 25px;}.paddingRight30 {padding-right: 30px;}.paddingRight35 {padding-right: 35px;}.paddingRight40 {padding-right: 40px;}.paddingRight45 {padding-right: 45px;}.paddingRight50 {padding-right: 50px;}.paddingRight55 {padding-right: 55px;}.paddingRight60 {padding-right: 60px;}.paddingRight65 {padding-right: 65px;}.paddingRight70 {padding-right: 70px;}.paddingRight75 {padding-right: 75px;}.paddingTopdef {padding-top: 20px;}.paddingTop5 {padding-top: 5px;}.paddingTop10 {padding-top: 10px;}.paddingTop15 {padding-top: 15px;}.paddingTop20 {padding-top: 20px;}.paddingTop25 {padding-top: 25px;}.paddingTop30 {padding-top: 30px;}.paddingTop35 {padding-top: 35px;}.paddingTop40 {padding-top: 40px;}.paddingTop45 {padding-top: 45px;}.paddingTop50 {padding-top: 50px;}.paddingTop55 {padding-top: 55px;}.paddingTop60 {padding-top: 60px;}.paddingTop65 {padding-top: 65px;}.paddingTop70 {padding-top: 70px;}.paddingTop75 {padding-top: 75px;}.printerFontSizedef{        font-size: 16px;}.printerFontSize6{        font-size: 6px;}.printerFontSize8{         font-size: 8px;}.printerFontSize10{        font-size: 10px;}.printerFontSize11{        font-size: 11px;}.printerFontSize12{        font-size: 12px;}.printerFontSize13{        font-size: 13px;}.printerFontSize14{        font-size: 14px;}.printerFontSize14{        font-size: 16px;}.printerFontSize18{        font-size: 18px;}.printerFontSize22{        font-size: 22px;}.printerFontSize28{        font-size: 28px;}.printerFontSize34{        font-size: 34px;}.printerFontSize55{        font-size: 55px;}.bgWhite{        background-color: white;} ';
        },
        beforeDestroy() {
            const modul = this;
            modul.$eventBus.$off('globalReadElement');
            modul.$eventBus.$off('globalAddPurcaseElement');
            modul.$eventBus.$off('globalSetBuyer');
            modul.offListener();
        },
        methods: {
          getElementFromCachedElementsById: function (itemKey) {
            const modul = this;
            const element = Helper.getObjectByIdFromObjectArray(modul.cachedElements, itemKey);
            return element;
          },
            makeBasketCalculation(){
                const modul = this;
                console.log("makeBasketCalculation");
                let sum = 0;
                modul.purcaseItemsExtend.forEach(function (item) {
                    sum += Number(item.itemSumPrice);

//                    let val = item.itemValue;
////                    let item = modul.getItemById(e.itemKey);
//                    if (Number(item.pack) === 1) {
//                        if (val && Number(val).toString() === val.toString()) {
//                            sum += Number(val);
//                        }
//                    } else if (Number(item.pack) >= 2 && Number(item.pack) <= 7) {
//                        if (val && Number(val).toString() === val.toString()) {
//                            sum += Number(item.default_price) * item.itemValue;
//                        }
//                    }
                });

                let sumDiscont = 0;
                const discount = modul.discount; //                const discount = modul.calculateDiscount(sum);

                sumDiscont = parseFloat(100 - Number(discount)) * parseFloat(0.01) * sum;
                sumDiscont = Helper.roundToProjectDecimal(sumDiscont);
                modul.sum = Helper.getFormattedPrice(sumDiscont);
                let discount_price = 0;
                if (discount && Number(discount).toString() === discount.toString() && discount !== 0) {
                    discount_price = Helper.roundToProjectDecimal(( Number(discount)) * parseFloat(0.01) * sum);
                }
                modul.discount_price = Helper.getFormattedPrice(discount_price);
            },
//            getElementByIdSync: function (id) {
//                const modul = this;
//                const elements = window.db.select(
//                    function (err, res) {
//                    }
//                    , "element", "*", "id=" + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0') "); // AND (`type` = 2 OR `type` = '2')
//                let element = {};
//                if (elements && elements[0] && elements[0].id) {
//                    element = elements[0];
//                }
//                return element;
//            },

            initSellDataContents(){
                const modul = this;

              modul.getSell(function (err, res) {
                if (res && res.id) {
                  // set sell data

                  modul.data = res;
                  const buyer = res.buyer;
                  const elements = res.elements;
                  const businesspartner = res.businesspartner;

                  modul.data.id = res.id;
                  modul.data.selltext = res.selltext;
                  modul.data.selltype = res.selltype;
                  modul.data.date = moment.utc(res.datetime, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD');
                  modul.data.datetime = moment.utc(res.datetime, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss');
                  modul.discount = (res.discount_type) ? res.discount_type : 0;
                  modul.data.discount_type = (res.discount_type) ? res.discount_type : 0;
                  // handle sell_element



//                        modul.getSellElementsBySellid(function (err, res) {
//                            if (res) {
                  let purcaseItems = [];
                  elements.forEach(function (e) {


                    let purcaseItem=({
                      itemPrice: Helper.getFormattedPrice(e.itemprice),
                      itemCountnum: e.countnum,
                      itemSumPrice: Helper.getFormattedPrice(e.price),
                      itemKey: Number(e.id_element)
                    });
                    purcaseItems.push( Object.assign(e,purcaseItem))

//                                    if (Number(e.pack) === 1) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.price)}); // countnum vagy price
//                                    } else if (Number(e.pack) >= 2 && Number(e.pack) <= 7) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.countnum)}); // countnum vagy price
//                                    }
                  });
                  modul.purcaseItems = purcaseItems; // purcaseItems;
//                            }
//                        }, modul.$route.params.sellId)

                  // handle buyer
                  modul.buyer = buyer;
                  if(buyer.id){
                    modul.$eventBus.$emit('globalReadBuyerSid', buyer.sid);
                  }
//                        const id_buyer = res[0].id_buyer;
//                        if (id_buyer) {
//                            modul.getBuyerById(function (err, res) {
//                                if (!err) {
//                                    if (res && res.id) { // res[0] &&
//                                        modul.buyer = res;
//                                        modul.$eventBus.$emit('globalReadBuyerSid', res.sid);
////                                        if(res[0].discount){
////                                            modul.discount = res[0].discount;
////                                        } else {
////                                            modul.discount = 0;
////                                        }
//                                    }
//                                }
//                            }, id_buyer)
//                        }


                  // handle businesspartner
                  if(businesspartner && businesspartner.id){
                    modul.businesspartner = businesspartner;
                    modul.$eventBus.$emit('globalSetBusinessPartner', businesspartner);
                  }
                  setTimeout(function () {
                    const printHidingElements = document.querySelectorAll(".printHiding");
                    printHidingElements.forEach(function (e, i) {
                      e.style.display = "none";
                    });
                    setTimeout(function () {
                      printHidingElements.forEach(function (e, i) {
                        e.removeAttribute('style');
                      })
                    }, 8000);
                    modul.printView();
                  }, 300);

//                      const id_businesspartner = res[0].id_businesspartner;
//                        if (id_businesspartner) {
//                            modul.getBusinessPartnerById(function (err, res) {
//                                if (!err) {
//                                    if (res && res.id) { // && res[0] && res[0].id
//                                        modul.businesspartner = res;
//                                        modul.$eventBus.$emit('globalSetBusinessPartner', res);
//                                    }
//                                }
//                            }, id_businesspartner)
//                        }

                }
              }, modul.$route.params.sellId)

//
//                if (modul.$route.params.sellId) {
//                    // TODO ide kell enek a lekérések, amik beolvassák az eladást!!
//                    modul.getSell(function (err, res) {
//                        if (res && res.id) {
//                            // set sell data
//                            modul.data = res;
//
//
//                          const buyer = res.buyer;
//
//                            const elements = res.elements;
//                          let purcaseItems = [];
//                          elements.forEach(function (e) {
//                            if (Number(e.pack) === 1) {
//                              purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.price)}); // countnum or price
//                            } else if (Number(e.pack) >= 2 && Number(e.pack) <= 7) {
//                              purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.countnum)}); // countnum or price
//                            }
//                          });
//                          modul.$eventBus.$emit('globalSetPurcaseElements', purcaseItems);
//                          setTimeout(function () {
//                            const printHidingElements = document.querySelectorAll(".printHiding");
//                            printHidingElements.forEach(function (e, i) {
//                              e.style.display = "none";
//                            });
//                            setTimeout(function () {
//                              printHidingElements.forEach(function (e, i) {
//                                e.removeAttribute('style');
//                              })
//                            }, 8000);
//                            modul.printView();
//                          }, 300);
//
//                          if(buyer.sid){
//                            modul.$eventBus.$emit('globalReadBuyerSid', buyer.sid);
//                          }
//
////                            modul.data.id = res.id;
////                            modul.data.selltext = res.selltext;
////                            modul.data.selltype = res.selltype;
////                            // handle sell_element
////                            modul.getSellElementsBySellid(function (err, res) {
////                                if (res) {
////                                    let purcaseItems = [];
////                                    res.forEach(function (e) {
////                                        if (Number(e.pack) === 1) {
////                                            purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.price)}); // countnum or price
////                                        } else if (Number(e.pack) >= 2 && Number(e.pack) <= 7) {
////                                            purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.countnum)}); // countnum or price
////                                        }
////                                    });
////                                    modul.$eventBus.$emit('globalSetPurcaseElements', purcaseItems);
////                                    setTimeout(function () {
////                                        const printHidingElements = document.querySelectorAll(".printHiding");
////                                        printHidingElements.forEach(function (e, i) {
////                                            e.style.display = "none";
////                                        });
////                                        setTimeout(function () {
////                                            printHidingElements.forEach(function (e, i) {
////                                                e.removeAttribute('style');
////                                            })
////                                        }, 8000);
////                                        modul.printView();
////                                    }, 300);
////                                }
////                            }, modul.$route.params.sellId)
//
//                            // handle buyer
////                            const id_buyer = res[0].id_buyer;
////                            if (id_buyer) {
////                                modul.getBuyerById(function (err, res) {
////                                    if (!err) {
////                                        if (res && res[0] && res[0].id) {
////                                            const buyer = res[0];
////                                            modul.$eventBus.$emit('globalReadBuyerSid', buyer.sid);
////                                        }
////                                    }
////                                }, id_buyer)
////                            }
//                        }
//                    }, modul.$route.params.sellId)
//                } else {
//                    console.log('nincs sellid !');
////                    modul.$router.push({
////                        name: "sellinone", params: {}
////                    });
//                }
            },
            addContent(){
                const modul = this;
                const cb = function (err, res) {
                    console.log(res);
                    modul.title = res.title;
                    modul.printblokk_top = res.printblokk_top;
                    modul.printblokk_bottom = res.printblokk_bottom;

                    // TODO ez nem tudom miért van
                    setTimeout(function () {
                        modul.initSellDataContents();
                    }, 0);
                };
                this.getContentsInMixObj(cb, 'printblokk');
            },
            getContentsInMixObj: function (cb, typec) {
                const modul = this;
                this._getContents(function (err, res) {
                    cb(err, modul._mixContentToObj(res))
                }, typec);
            },
            _getContents: function (cb, typec) {
//                let wsid = machineIdSync();
              const wsid = localStorage.getItem("browserIdentifier");

              Api.getContents({id:wsid,typec:typec}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });

//              window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "content", "*", "(`deleted` = 0 OR `deleted` = '0') AND typec='" + typec + "' AND (wsid='' OR wsid is null OR wsid='" + wsid + "' )", "keyc asc");
            },
            _mixContentToObj: function (arr) {
                const ret = {};
                if (Array.isArray(arr)) {
                    Array.prototype.forEach.call(arr, function (row) {
                        if (!ret[row['typec_sub']]) {
                            ret[row['typec_sub']] = [];
                        }
                        ret[row['typec_sub']].push(row['valuec']);
                        ret[row['keyc']] = row['valuec']
                    });
                }
                return ret;
            },
            printView: function () {
              const modul = this;
              window.print();
//              Helper.printElement("printContent",modul.printStyle)
//                ipcRenderer.send('printpage', 'ping');
            },

            initListener: function (redirectToName) {
                const modul = this;
//                ipcRenderer.removeAllListeners('printpage-reply');
//                ipcRenderer.on('printpage-reply', (event, arg) => {
//                    console.log(arg);
//                    if (arg === true) {
//                        console.log("true");
//                    }
//                    if (arg === false) {
//                        console.log("false");
//                    }
//                    const message = `Asynchronous message reply: ${arg}`
//                    console.log(message);
////                    if (arg === true) {
//                    console.log("redirect to sellinone")
//                    modul.$router.push({
//                        name: "sellinone", params: {}
//                    });
////                    }
//                });
            },
            offListener: function (redirectToName) {
//                ipcRenderer.removeAllListeners('printpage-reply');
            },
            globalSetPurcaseItemsEventHandler(purcaseItems){
                this.purcaseItems = purcaseItems;
            },
            globalSetBuyerEventHandler(buyer){
                this.buyer = Object.assign({}, buyer);
            },
            globalSetBasketCalculationEventHandler(basketCalculation){
                const modul = this;
                modul.sum = basketCalculation.sum;
                modul.discount_price = basketCalculation.discount_price;
            },
            go_new: function () {
                const modul = this;
                modul.$router.push({
                    name: "sellinone", params: {}
                });
            },
            getSell: function (cb, id) {
                const modul = this;
              Api.getSell({id:id}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });

//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell left join buyer on buyer.id = sell.id_buyer", "*, concat(pre_name, ' ',first_name, ' ',last_name) buyertext, sell.id id", "sell.id=" + id);
            },
            emptyForNew(){
                const modul = this;
                this.data = Object.assign({}, modul.dataBase);
                this.stock = {};
                this.$router.push({name: "selproduct"})
            },
            /**
             * Ha vissza-val jövünk szerkesztésre
             * @param cb
             * @param id_sell
             */
            getSellElementsBySellid: function (cb, id_sell) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell_element left join element on element.id = sell_element.id_element", "*", "id_sell=" + id_sell); // left join element on element.id = sell_element.id_element  -- , element.id id
            },
            getBuyerById: function (cb, id) {
              Api.getBuyer({id:id}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "buyer", "*", "id=" + id + " AND (`deleted` = 0 OR `deleted` = '0')");
            },

        },
        components: {
            LinkToTemplate,
            InputText,
            SellHeader,
            AlertInPage,
            BarcodeGenerator,
            BuyerSearcher,
            ProductSearcher,
            ProductTabs,
            BasketDisplayer
        },
    };
</script>


<style>


</style>
<style scoped>

    .printpage {
        color: black;
    }

    body .sellprint {
        display: block !important;

    }

    .pricesTable {
        width: 100%;
    }

    .tdRight {
        width: 1%;
        padding: 0.1em;
        vertical-align: initial;
    }

    /*@media print {*/

    body {
        color: #000;
        background: #fff;
    }

    /* TODO -- Ez a printkor formázzuk, nem jó*/
    body .sellprint {
        display: block !important;

    }

    /* upper developer menü */
    body .adminmenu {
        display: none !important;
    }

    /* default body margin */
    body {
        margin: 0 0 !important;
        width: 260px !important;
    }

    /* color */
    body, body .text-muted, body label.sum {
        color: #000 !important;
        background-color: #fff !important;
    }

    body label, .content {
        margin: 0 !important;
        padding: 0 !important;

    }

    .content,
    .card-body,
    .row,
    .col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
        margin: 0 !important;
        padding: 0 !important;

    }

    .card, .card-header, .card-footer {
        margin: 0 !important;
        padding: 0 !important;

        border: none !important;
        background-color: white !important;
    }

    /* szépítés */
    .printprice {
        font-weight: bolder;
        padding-right: 10px;
    }

    .elementsTitle .col {
        font-weight: bolder;

    }

    body {
        font-size: 15px;
    }

    /*.text-justify{*/
    /*text-align: justify;*/
    /*margin-bottom: -14px !important;*/
    /*}*/
    /*.text-justify:after{*/
    /*content: "";*/
    /*display: inline-block;*/
    /*width: 100%;*/
    /*}*/
    @page {
        margin: 0;
    }

    /*.basketDisplayerContainer .extensionLine:after {*/
    /*display: none;*/
    /*border-top:none;*/
    /*}*/

    /*body .table td, body .table th{*/
    /*padding:0;*/
    /*}*/

    /*}*/

    .table {
        display: table;
    }

    body .table td, body .table th {
        border-top: none;
    }

    /*@media print {*/
    body .table td, body .table th {
        padding: 0;
    }

    body .table {
        margin-bottom: 0;
        padding: 0;
    }

    /*}*/

</style>
